import * as React from 'react';

// Hook made for finding prev states of useState variables
const usePrevious = (value: any) => {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export default usePrevious;
